import React, { FC } from "react";
import AppBar from "../../components/layout/AppBar";
import nyc_sunrise from "../../assets/media/nyc_sunrise.mp4";
import { Link } from "react-router-dom";

const LandingPage: FC = () => {
  return (
    <div className="h-screen w-screen flex flex-col">
      {/* App Bar */}
      <div className="px-8 md:px-16 lg:px-24 py-4 bg-white/30 backdrop-blur-md fixed w-full z-50">
        <div className="max-w-7xl mx-auto">
          <Link to="/" className="text-2xl font-bold text-gray-900">
            Tibi
          </Link>
        </div>
      </div>

      {/* Main content container with gradient background */}
      <div className="flex-1 bg-gradient-to-tr from-yellow-200 via-orange-300 to-pink-300 px-8 md:px-16 lg:px-24  pt-10">
        {/* Content wrapper */}
        <div className="max-w-7xl mx-auto h-full flex items-center">
          {/* Left side content */}
          <div className="w-full lg:w-1/2 pt-20 lg:pt-0">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6">
              Let your journal talk to you
            </h1>
            <p className="text-xl md:text-2xl text-gray-800 mb-8">
              Tibi prompts you to reflet, checks in on you, and recommends
              things to you.
            </p>

            {/* Buttons */}
            <div className="flex gap-4">
              <Link
                to="/download"
                className="px-6 py-3 bg-black text-white rounded-full font-medium flex items-center gap-2 hover:bg-gray-800 transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                  />
                </svg>
                Get the App
              </Link>
              <a
                href="mailto:hello@ddl-labs.com"
                className="px-6 py-3 bg-white text-black rounded-full font-medium hover:bg-gray-100 transition-colors"
              >
                Contact
              </a>
            </div>
          </div>

          {/* Right side - Phone mockup */}
          <div className="hidden lg:block w-1/2 ">
            <img
              src={require("../../assets/media/IMG_3371.PNG")}
              alt="Tibi app screenshot showing a journal entry about a sushi dinner"
              className="w-[300px] h-auto ml-auto rounded-[40px] shadow-2xl"
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="px-8 md:px-16 lg:px-24 py-4 bg-transparent">
        <div className="max-w-7xl mx-auto text-sm text-gray-600">
          © 2024 DDL Labs, Inc. |{" "}
          <a href="tel:+14083419215" className="hover:text-gray-900">
            +1 (408) 341-9215
          </a>{" "}
          | <span>1035 Campus Dr, Stanford, CA 94305</span> |{" "}
          <a href="/tos.html" className="hover:text-gray-900" target="_blank">
            Terms of Service
          </a>{" "}
          |{" "}
          <a
            href="/privacy.html"
            className="hover:text-gray-900"
            target="_blank"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
